import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceV5 extends Component {

    render() {

    let publicUrl = process.env.PUBLIC_URL+'/'
    let imagealt = 'image'

    return	<section className="service-two service-two__service-page  go-top">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-5">
		        <div className="service-two__block">
		          <div className="block-title-two text-left">
		            <p>Our Services</p>
		            <h3>Exclusive <br /> Service For You</h3>
		          </div>{/* /.block-title-two */}
		          <p>We empower businesses with intelligent automation solutions designed to enhance customer support, drive more leads, and streamline sales. Our AI-driven chat and voice systems integrate seamlessly with your website, eCommerce store, or social platforms, helping you engage customers instantly and convert conversations into revenue.</p>

					<div className="block-title-two text-left mb-2">
						<h4>Conversational Solution </h4>
					</div>

					<p>Our smart Chat Agent connects directly to your website, handling everything from answering common questions to capturing leads, recommending products, and guiding users through your services. It learns from your business data and interacts naturally, providing 24/7 support without the need for human agents.</p>

					<div className="block-title-two text-left">
						<p>Features include:</p>
					</div>
					<ul className="video-one__list">
						<li><i className="far fa-check" /> Real-time visitor engagement</li>
						<li><i className="far fa-check" /> Custom conversation flows</li>
						<li><i className="far fa-check" /> Product recommendations</li>
						<li><i className="far fa-check" /> FAQ handling</li>
						<li><i className="far fa-check" /> Lead form automation</li>
						<li><i className="far fa-check" /> CRM integration</li>
					</ul>{/* /.list-unstyled video-one__list */}
		          {/* /.thm-btn */}
		        </div>{/* /.service-two__block */}
		      </div>{/* /.col-lg-5 */}
		      <div className="col-lg-7">
		        <div className="service-two__box-wrap">
		          <div className="row">
		            <div className="col-md-6">
		              <div className="service-two__single js-tilt">
		                <div className="service-two__single-image" style={{backgroundImage: 'url('+publicUrl+'assets/images/backgrounds/service-1-new.jpg)'}} />
		                {/* /.service-two__single-image */}
		                <div className="service-two__single-inner">
		                  <i className="fal fa-hand-holding-usd" />
		                  <h3><Link to="/voice-ai-calling-system">Voice AI Calling System</Link></h3>
		                  <p>Human-like voice calls for follow-ups and lead nurturing.</p>
		                  <Link to="/voice-ai-calling-system" className="service-two__link"><i className="fa fa-long-arrow-alt-right" /></Link>
		                  {/* /.service-two__link */}
		                </div>{/* /.service-two__single-inner */}
		              </div>{/* /.service-two__single */}
		            </div>{/* /.col-md-6 */}
		            <div className="col-md-6">
		              <div className="service-two__single js-tilt">
		                <div className="service-two__single-image" style={{backgroundImage: 'url('+publicUrl+'assets/images/backgrounds/service-2-new.jpg)'}} />
		                {/* /.service-two__single-image */}
		                <div className="service-two__single-inner">
		                  <i className="fal fa-umbrella-beach" />
		                  <h3><Link to="/lead-generation-automation">Lead Generation Automation</Link></h3>
		                  <p>Turn every conversation into a qualified business opportunity.</p>
		                  <Link to="/lead-generation-automation" className="service-two__link"><i className="fa fa-long-arrow-alt-right" /></Link>
		                  {/* /.service-two__link */}
		                </div>{/* /.service-two__single-inner */}
		              </div>{/* /.service-two__single */}
		            </div>{/* /.col-md-6 */}
		            <div className="col-md-6">
		              <div className="service-two__single js-tilt">
		                <div className="service-two__single-image" style={{backgroundImage: 'url('+publicUrl+'assets/images/backgrounds/service-3-new.jpg)'}} />
		                {/* /.service-two__single-image */}
		                <div className="service-two__single-inner">
		                  <i className="fal fa-paper-plane" />
		                  <h3><Link to="/social-media-chatbot-integration">Social Media Chat Agent Integration</Link></h3>
		                  <p>Engage customers where they already spend their time.</p>
		                  <Link to="/social-media-chatbot-integration" className="service-two__link"><i className="fa fa-long-arrow-alt-right" /></Link>
		                  {/* /.service-two__link */}
		                </div>{/* /.service-two__single-inner */}
		              </div>{/* /.service-two__single */}
		            </div>{/* /.col-md-6 */}
		            <div className="col-md-6">
		              <div className="service-two__single js-tilt">
		                <div className="service-two__single-image" style={{backgroundImage: 'url('+publicUrl+'assets/images/backgrounds/service-4-new.jpg)'}} />
		                {/* /.service-two__single-image */}
		                <div className="service-two__single-inner">
		                  <i className="fal fa-chart-network" />
		                  <h3><Link to="/real-time-dashboard-analytics">Real-Time Dashboard & Analytics</Link></h3>
		                  <p>Track performance, customer activity, and conversation quality.</p>
		                  <Link to="/real-time-dashboard-analytics" className="service-two__link"><i className="fa fa-long-arrow-alt-right" /></Link>
		                  {/* /.service-two__link */}
		                </div>{/* /.service-two__single-inner */}
		              </div>{/* /.service-two__single */}
		            </div>{/* /.col-md-6 */}
		          </div>{/* /.row */}
		        </div>{/* /.service-two__box-wrap */}
		      </div>{/* /.col-lg-7 */}
		    </div>{/* /.row */}
		  </div>{/* /.container */}
		</section>

        }
}

export default ServiceV5